'use client'

import { api } from '@/api'
import { DOMAIN_ACTION } from '@/constants'
import { axiosPrivateHelper } from '@/utils/axiosHelper'
import { types } from 'mobx-state-tree'
const axios = axiosPrivateHelper()

type AdminType = {
  id: number
}

export const adminModel = types
  .model('AdminModel')
  .props({
    id: types.number,
  })
  .actions((self: any) => {
    const setProfile = (value: AdminType) => {
      self.id = value.id
    }

    const updateSupplier = async (payload: any, id: number) => {
      const [err, response] = await api.be.admin.putSupplier(id, payload)
      // for backwards compatibility rethrowing error here
      if (err) {
        throw err
      }

      return response
    }

    const createNewTag = async (payload: any) => {
      const URL = `${DOMAIN_ACTION.API.ADMIN.CREATE_NEW_TAG}`
      const response = await axios.post(URL, payload)
      return response
    }

    const createTag = async (payload: any) => {
      const URL = `${DOMAIN_ACTION.API.ADMIN.CREATE_SUPPLIER_TAG}`
      const response = await axios.post(URL, payload)
      return response
    }

    const updateSupplierAccount = async (id: number, payload: any) => {
      const URL = `${DOMAIN_ACTION.API.ADMIN.UPDATE_SUPPLIER_ACCOUNT_BY_ID(id)}`
      const response = await axios.post(URL, payload)
      return response
    }

    const nudgeApply = async (id: number) => {
      const URL = `${DOMAIN_ACTION.API.ADMIN.SUPPLIER_NUDGE_APPLY(id)}`
      const response = await axios.post(URL)
      return response
    }

    const deleteMember = async (payload: any, id: number) => {
      const URL = `${DOMAIN_ACTION.API.ADMIN.DELETE_MEMBER(id)}`
      const response = await axios.put(URL, payload)
      return response
    }

    const updateMember = async (payload: any, id: number) => {
      const URL = `${DOMAIN_ACTION.API.ADMIN.UPDATE_MEMBER_BY_ID(id)}`
      const response = await axios.put(URL, payload)
      return response
    }

    const nudgeListing = async (id: number) => {
      const URL = `${DOMAIN_ACTION.API.ADMIN.SUPPLIER_NUDGE_LISTING(id)}`
      const response = await axios.post(URL)
      return response
    }

    return {
      setProfile,
      updateSupplier,
      createNewTag,
      createTag,
      updateSupplierAccount,
      nudgeApply,
      deleteMember,
      updateMember,
      nudgeListing,
    }
  })
